import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getTuinaTherapistOnDuty } from '@/service/tuina'

const processSingleDataType = ({ data, dataType }) => {
  const list = Array.isArray(data) ? data : []
  if (!dataType || dataType === 'default') return list
  switch (dataType) {
    case 'option':
      return list.map((item) => ({
        id: `${item.id}`,
        value: item.status === 'off_duty' ? `${item.name} 离` : item.name
      }))
    default:
      return list
  }
}

export const fetchTuinaTherapistOnDuty = createAsyncThunk(
  'tuinaTherapistOnDuty/fetchTuinaTherapistOnDuty',
  async ({ query = {}, dataType } = {}, { rejectWithValue }) => {
    try {
      const response = await getTuinaTherapistOnDuty(query)
      return {
        data: response.data,
        query,
        dataType
      }
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.msg ||
          error?.response?.data?.message ||
          error?.msg ||
          error?.message ||
          '加载师傅失败'
      )
    }
  }
)

const therapistOnDutySlice = createSlice({
  name: 'tuinaTherapistOnDuty',
  initialState: {
    fetching: false,
    error: null,
    query: {},
    data: []
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTuinaTherapistOnDuty.pending, (state) => {
        state.fetching = true
        state.error = null
      })
      .addCase(fetchTuinaTherapistOnDuty.fulfilled, (state, action) => {
        const { data, dataType, query } = action.payload || {}
        state.fetching = false
        state.error = null
        state.query = query
        state.data = processSingleDataType({ data, dataType })
      })
      .addCase(fetchTuinaTherapistOnDuty.rejected, (state, action) => {
        state.fetching = false
        state.error = action.payload ?? action.error?.message ?? null
      })
  }
})

export default therapistOnDutySlice.reducer
